import moment from 'moment-timezone'
import formInput from '@/components/common/form-input/form-input.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import { mapState, mapActions } from 'vuex'
import VJsoneditor from '@/components/common/json-editor'
import IsoLanguageJSON from '@/helpers/ISO-639-1-language.json'
import { find } from 'lodash'

export default {
  components: {
    formInput,
    formButton,
    Multiselect,
    VJsoneditor
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    template: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      options: {
        mode: 'code',
        modes: ['code', 'text', 'view', 'form'],
        search: false,
        statusBar: false,
        sortObjectKeys: false
      },
      timezones: moment.tz.names(),
      designTypes: ['custom', 'existing'],
      languages: IsoLanguageJSON
    }
  },
  computed: {
    ...mapState('template', ['ageOptions']),
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('workflow', ['workflowList']),
    isFormFilled: function () {
      return Boolean(
        this.template.name &&
          this.template.age &&
          this.template.language &&
          this.template.desc &&
          this.template.preparation_time &&
          this.template.mechanic &&
          this.template.design &&
          this.template.design_type &&
          this.template.design_config &&
          this.template.image &&
          this.template.workflow
      )
    },
    languageOptions: function () {
      return IsoLanguageJSON.map((language) => language.code)
    }
  },
  methods: {
    ...mapActions('workflow', ['getWorkflowsList']),
    onCreateEditTemplate: async function () {
      try {
        await this.$validator.validate()
        if (this.errors.items.length === 0) {
          this.$emit('onCreateEditTemplate', this.template)
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    },
    nameWithLang(code) {
      const language = find(IsoLanguageJSON, ['code', code])
      return `${language.name} — [${language.code}]`
    }
  },
  created() {
    this.getWorkflowsList({})
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/templates/template-add-edit-content/template-add-edit-content.js